module.exports = __webpack_public_path__ + "static/media/8OLA9.a2996518.jpg";